import 'owl.carousel';

function closeModal()
{
	const body = document.querySelector('body');

	body.classList.remove('modal-active');
}

export function sliders()
{
	const sliders = $('.slider');
	const body = $('body');

	sliders.each(function()
	{
		let _this = $(this);
		let showDots = $(this).attr('data-slider') ? true : false;
		let showNav  = $(this).attr('data-nav') ? true : false;
		let module = $(this).attr('data-module') ? true : false;
		let autoplay = $(this).attr('data-auto') ? true : false;
		let margin = module ? 48 : 0;
		let marginMobile = module ? 16 : 0;
		let padding = module ? 420 : 0;
		let paddingMobile = module ? 48 : 0;
		let paddingTablet = module ? 180 : 0;

		let options = {
			items: 1,
			dots: showDots,
			touchDrag: true,
			mouseDrag: true,
			center: true,
			nav: showNav,
			autoplay: autoplay,
			autoplayTimeout: 3600 + 1200,
			smartSpeed: 1200,
			navText: [
				'<svg viewBox="0 0 12 20"><use xlink:href="#icon-larr"></use></svg>',
				'<svg viewBox="0 0 12 20"><use xlink:href="#icon-rarr"></use></svg>',
			],
			loop: true,
			responsive: {
				0: {
					nav: false,
					stagePadding: paddingMobile,
					margin: marginMobile,
				},
				700: {
					nav: showNav,
					stagePadding: paddingTablet,
					margin: marginMobile,
				},
				1439: {
					nav: showNav,
					stagePadding: padding,
					margin: margin,
				},
			},
		};

		$(this).owlCarousel(options);

		$(document).on('keydown', function (event)
		{ //attach event listener
			if (event.keyCode == 37)
			{
				_this.trigger('prev.owl')
			}
			if (event.keyCode == 39)
			{
				_this.trigger('next.owl')
			}

			console.log(event.keyCode)

			if (event.keyCode == 27 && body.hasClass('modal-active'))
			{
				closeModal()
			}
		});

		$('.modal-trigger').on('click', (e) =>
		{
			let modalTrigger = e.target;
			let index = modalTrigger.getAttribute('data-index');

			body.addClass('modal-active');
			_this.trigger('to.owl.carousel', [index, 400]);
		})
	});

	const modalClose = document.querySelectorAll('.modal-close');

	modalClose.forEach( (el) => {
		el.addEventListener('click', closeModal)
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js